import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9ab89334"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title" }, " Создание наименования рекламной кампании ", -1))
const _hoisted_4 = { class: "flex some-inputs" }
const _hoisted_5 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Бренд*", -1))
const _hoisted_7 = {
  key: 0,
  class: "hand"
}
const _hoisted_8 = {
  key: 1,
  class: "hand"
}
const _hoisted_9 = { class: "flex flex-col input-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Магазин*", -1))
const _hoisted_11 = {
  key: 0,
  class: "hand"
}
const _hoisted_12 = {
  key: 1,
  class: "hand"
}
const _hoisted_13 = { class: "flex some-inputs m-t-8" }
const _hoisted_14 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Стратегия", -1))
const _hoisted_16 = { class: "flex flex-col input-container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Дополнительное поле", -1))
const _hoisted_18 = { class: "flex some-inputs m-t-8" }
const _hoisted_19 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Период запуска рекламной кампании от*", -1))
const _hoisted_21 = { class: "flex flex-col input-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Период запуска рекламной кампании до*", -1))
const _hoisted_23 = { class: "form-block" }
const _hoisted_24 = { class: "flex flex-col fl-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Название рекламной кампании", -1))
const _hoisted_26 = {
  key: 0,
  class: "info-block flex"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-info-circle info" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Если бренд или магазин указан вручную, Вы не сможете использовать данные кампаний для дашбордов или отчёта Sales Lift. Также нельзя отправить кампанию в те кабинеты, по которым идёт сбор статистики для дашбордов. ", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "flex flex-end m-b-8" }
const _hoisted_31 = { class: "flex flex-col fl-1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Сегмент*", -1))
const _hoisted_33 = { class: "flex fl-jc-sb f-s-0 m-l-20 m-b-7 m-l-20" }
const _hoisted_34 = { class: "flex some-inputs" }
const _hoisted_35 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Рекламная площадка*", -1))
const _hoisted_37 = { class: "flex flex-col input-container" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Кабинет*", -1))
const _hoisted_39 = {
  key: 0,
  class: "flex f-s-0 m-t-12"
}
const _hoisted_40 = { class: "p-r-20" }
const _hoisted_41 = { class: "pi pi-info-circle icon-right" }
const _hoisted_42 = { class: "group-button-container flex" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-l-10" }, "Сегмент", -1))
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]

import { ref, watch, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import CalendarBaseInput from "@/shared/forms/CalendarBaseInput.vue";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import DuplicatedCampaignDialog from "@/shared/dialogs/DuplicatedCampaignDialog.vue";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import TechCampaignToggle from "./TechCampaignToggle.vue";

import { Brand } from "@/store/catalog_data/brands";
import { Shop } from "@/store/catalog_data/shops";
import { useCampaignStore, type Campaign } from "@/store/campaigns/campaigns";
import {
  getCampaignName,
  isCampaignNameValidated,
  isSegmentsFilled,
  isNotValidPeriod,
  prepareModelToServer,
  convertServerToModel,
} from "@/services/campaigns/utils";
import { rootGetters } from "@/main";
import { useAuthStore } from "@/store/auth/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignCreateForm',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ["setCreateButton", "setLoading"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;


const route = useRoute();
const router = useRouter();
const store = useCampaignStore();
const authStore = useAuthStore();
const isNameFilled = ref(false);
const isInvalidForm = ref(false);
const confirmVisible = ref({
  duplicate: false,
});

const customCatalogData = ref({
  brand: false,
  shop: false,
});

const duplicatedId = ref(0);
const useNameDefault = ref(false);
const nameDefault = ref<typeof campaign.value | null>(null);
const isLoadingData = ref(false);

const campaign = ref({
  brand: null as Brand | null,
  shop: null as Shop | null,
  brand_name: "",
  shop_name: "",
  name: "",
  strategy: "",
  extra_info: "",
  date_from: null as Date | null,
  date_to: null as Date | null,
  campaign_segments: [
    {
      segment_id: null as number | null,
      segment: null as object | null,
      ads_cabinet_id: null as number | null,
      platform_slug: null as string | null,
      is_segment_updatable: false,
      updatable_locked: false,
      is_segment_auto_renewable: false,
    },
  ],
});

const campaignData = computed(() => campaign.value);

const campaignWatchFields = computed(() => ({
  brand: campaign.value.brand,
  shop: campaign.value.shop,
  name: campaign.value.name,
  strategy: campaign.value.strategy,
  extra_info: campaign.value.extra_info,
  date_from: campaign.value.date_from,
  date_to: campaign.value.date_to,
  brand_name: campaign.value.brand_name,
  shop_name: campaign.value.shop_name,
}));

const adsCabinetFilterFields = computed(() => {
  if (customCatalogData.value.brand || customCatalogData.value.shop)
    return ["source_slug", "is_statistics_required"];
  return ["source_slug"];
});

const adsCabinetFilterValues = computed(() => {
  if (customCatalogData.value.brand || customCatalogData.value.shop)
    return [false];
  return [];
});

const isCampaignSetted = computed(() => {
  return Boolean(route.params.id);
});

const campaignName = computed(() => {
  return getCampaignName(campaign.value, useNameDefault.value);
});

const chooseSegment = (segment: any, event: any) => {
  if (event) {
    segment.segment_id = event.id;
    if (event.is_fixed_end_date) segment.updatable_locked = true;
  } else {
    segment.segment_id = null;
  }

  segment.segment = event;
};

const reload = () => {
  if (isCampaignSetted.value || store.duplicateCampaignId) {
    const campaignIdParam = Array.isArray(route.params.id)
      ? route.params.id[0]
      : route.params.id;
    const campaignId =
      parseInt(campaignIdParam as string) || store.duplicateCampaignId;
    isLoadingData.value = true;
    store.getCampaign(campaignId).then((campaignClone) => {
      if (campaignClone) {
        campaign.value = convertServerToModel(campaignClone);
        useNameDefault.value = true;
        isLoadedFirst.value = true;
        nameDefault.value = JSON.parse(JSON.stringify(campaign.value));
        customCatalogData.value.brand = !!campaign.value.brand_name;
        customCatalogData.value.shop = !!campaign.value.shop_name;
      }
      if (store.duplicateCampaignId) {
        const extraValue = campaign.value.extra_info
          ? campaign.value.extra_info
          : "";
        campaign.value.extra_info = extraValue + "копия";
      }
      isLoadingData.value = false;
    });
  }
};

onMounted(() => {
  reload();
});

watch(
  () => campaignName.value,
  () => {
    isNameFilled.value = isCampaignNameValidated(campaign.value);
  }
);

watch(
  () => route.params.id,
  () => {
    reload();
  }
);

const isLoadedFirst = ref(true);

watch(campaignWatchFields, (newValue) => {
  if (nameDefault.value) {
    const defaultVal = nameDefault.value;
    if (
      (!isLoadedFirst.value || store.duplicateCampaignId) &&
      useNameDefault.value &&
      (newValue.extra_info !== defaultVal.extra_info ||
        newValue.brand !== defaultVal.brand ||
        newValue.shop !== defaultVal.shop ||
        newValue.strategy !== defaultVal.strategy ||
        newValue.date_from !== defaultVal.date_from ||
        newValue.date_to !== defaultVal.date_to ||
        newValue.brand_name !== defaultVal.brand_name ||
        newValue.shop_name !== defaultVal.shop_name)
    ) {
      useNameDefault.value = false;
    }
  }
  if (useNameDefault.value != undefined) isLoadedFirst.value = false;
});

const addSegment = (idx: number) => {
  campaign.value.campaign_segments.splice(idx + 1, 0, {
    segment_id: null,
    ads_cabinet_id: null,
    segment: null,
    platform_slug: null,
    is_segment_updatable: false,
    updatable_locked: false,
    is_segment_auto_renewable: false,
  });
};

const deleteSegment = (idx: number) => {
  campaign.value.campaign_segments.splice(idx, 1);
};

const createCampaign = () => {
  if (!isNameFilled.value || !isSegmentsFilled(campaign.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены и наименования бренда и магазина не содержат нижнее подчеркивание.`
    );
    return;
  } else if (isNotValidPeriod(campaign.value)) {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Дата начала периода не может быть больше даты окончания.`
    );
    return;
  }
  campaign.value.name = campaignName.value;
  const campaignForCreation = prepareModelToServer(campaign.value);
  if (campaignForCreation) {
    emit("setLoading", true);
    if (isCampaignSetted.value) {
      const campaignIdParam = Array.isArray(route.params.id)
        ? route.params.id[0]
        : route.params.id;
      const campaignId = parseInt(campaignIdParam as string);
      performCampaignAction(() =>
        store.updateCampaign(campaignForCreation, campaignId)
      );
    } else {
      performCampaignAction(() => store.createCampaign(campaignForCreation));
    }
  }
};

const performCampaignAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "listCampaigns" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  const handleCampaignError = (err: any) => {
    if (err.response && err.response.status == 409)
      store.getCampaignByName(campaign.value.name).then((id) => {
        if (id) {
          duplicatedId.value = id;
          confirmVisible.value.duplicate = true;
        }
      });

    if (err.response && err.response.status == 403)
      rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
  };

  action()
    .then(handleCampaignSuccess)
    .catch(handleCampaignError)
    .finally(() => {
      emit("setLoading", false);
    });
};

const getMessage = (isNameFilled: boolean) => {
  if (isNameFilled) return "Наименование рекламной кампании корректно";
  return "Наименование рекламной кампании некорректно";
};

const hasBrandSelected = () => {
  return campaign.value.brand != null;
};

const setLoading = (value: boolean) => {
  emit("setLoading", value);
};

const updateCampaignFromToggle = (value: Campaign) => {
  Object.assign(campaign.value, value);
};

__expose({
  createCampaign,
  hasBrandSelected,
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              (!customCatalogData.value.brand)
                ? (_openBlock(), _createBlock(CatalogDataSingleInput, {
                    key: 0,
                    selectType: "brand",
                    "is-invalid": isInvalidForm.value && campaign.value.brand == null,
                    isSegmentSetted: false,
                    modelValue: campaign.value.brand,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (campaign.value.brand = $event))
                  }, null, 8, ["is-invalid", "modelValue"]))
                : (_openBlock(), _createBlock(_unref(InputText), {
                    key: 1,
                    placeholder: "Введите значение",
                    modelValue: campaign.value.brand_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((campaign.value.brand_name) = $event))
                  }, null, 8, ["modelValue"]))
            ]),
            _: 1
          }, 8, ["is-loading"]),
          (_unref(authStore).getPayloadTenant() != _unref(rootGetters).inhouse_tenant)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!customCatalogData.value.brand)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        _createTextVNode(" Не нашли бренд в списке? "),
                        _createElementVNode("span", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {
                    customCatalogData.value.brand = true;
                    campaign.value.brand = null;
                  })
                        }, "Ввести вручную")
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => {
                    customCatalogData.value.brand = false;
                    campaign.value.brand_name = '';
                  })
                        }, "Выбрать из списка")
                      ])
                    ]))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              (!customCatalogData.value.shop)
                ? (_openBlock(), _createBlock(CatalogDataSingleInput, {
                    key: 0,
                    selectType: "shop",
                    "is-invalid": isInvalidForm.value && campaign.value.shop == null,
                    isSegmentSetted: false,
                    modelValue: campaign.value.shop,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (campaign.value.shop = $event))
                  }, null, 8, ["is-invalid", "modelValue"]))
                : (_openBlock(), _createBlock(_unref(InputText), {
                    key: 1,
                    placeholder: "Введите значение",
                    modelValue: campaign.value.shop_name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((campaign.value.shop_name) = $event))
                  }, null, 8, ["modelValue"]))
            ]),
            _: 1
          }, 8, ["is-loading"]),
          (_unref(authStore).getPayloadTenant() != _unref(rootGetters).inhouse_tenant)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!customCatalogData.value.shop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createTextVNode(" Не нашли магазин в списке? "),
                        _createElementVNode("span", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                    customCatalogData.value.shop = true;
                    campaign.value.shop = null;
                  })
                        }, "Ввести вручную")
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => {
                    customCatalogData.value.shop = false;
                    campaign.value.shop_name = '';
                  })
                        }, "Выбрать из списка")
                      ])
                    ]))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: campaign.value.strategy,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((campaign.value.strategy) = $event)),
                disabled: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: campaign.value.extra_info,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((campaign.value.extra_info) = $event)),
                disabled: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CalendarBaseInput, {
                modelValue: campaign.value.date_from,
                "is-invalid": isInvalidForm.value && campaign.value.date_from == null,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (campaign.value.date_from = $event)),
                disabled: false
              }, null, 8, ["modelValue", "is-invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CalendarBaseInput, {
                "min-date": new Date(),
                modelValue: campaign.value.date_to,
                "is-invalid": isInvalidForm.value && campaign.value.date_to == null,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (campaign.value.date_to = $event)),
                disabled: false
              }, null, 8, ["min-date", "modelValue", "is-invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      (!isCampaignSetted.value)
        ? (_openBlock(), _createBlock(TechCampaignToggle, {
            key: 0,
            campaign: campaignData.value,
            isLoadingData: isLoadingData.value,
            "onUpdate:campaign": updateCampaignFromToggle,
            onSetLoading: setLoading
          }, null, 8, ["campaign", "isLoadingData"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_unref(InputIcon), {
                  class: _normalizeClass(["pi", 
                isNameFilled.value
                  ? 'pi-check-circle violete'
                  : 'pi-exclamation-circle red'
              ])
                }, null, 8, ["class"]), [
                  [_directive_tooltip, {
                value: getMessage(isNameFilled.value),
                class: 'white-tooltip',
              }]
                ]),
                _createVNode(_unref(InputText), {
                  class: "campaign-name",
                  placeholder: "Введите название",
                  modelValue: campaignName.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((campaignName).value = $event)),
                  disabled: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      (customCatalogData.value.brand || customCatalogData.value.shop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campaign.value.campaign_segments, (segment, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["form-block", [idx != campaign.value.campaign_segments.length - 1 ? 'hidden' : '']]),
        key: `segment-${idx}`
      }, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(CatalogDataSingleInput, {
                  "is-invalid": isInvalidForm.value && segment.segment_id == null,
                  selectType: "segment",
                  isSegmentSetted: false,
                  modelValue: segment.segment,
                  "onUpdate:modelValue": ($event) => chooseSegment(segment, $event)
                }, null, 8, ["is-invalid", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("label", {
              class: _normalizeClass(["p-r-20 pointer", [segment.updatable_locked ? 'locked' : '']]),
              for: "updated"
            }, "Обновлять сегмент", 2),
            _createVNode(_unref(InputSwitch), {
              modelValue: segment.is_segment_updatable,
              "onUpdate:modelValue": ($event: any) => ((segment.is_segment_updatable) = $event),
              disabled: segment.updatable_locked,
              inputId: "updated"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(CatalogDataSingleInput, {
                  "not-search": true,
                  "use-id-only": true,
                  selectType: "platform",
                  "is-invalid": isInvalidForm.value && segment.platform_slug == null,
                  isSegmentSetted: false,
                  modelValue: segment.platform_slug,
                  "onUpdate:modelValue": ($event) => (segment.platform_slug = $event)
                }, null, 8, ["is-invalid", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(CatalogDataSingleInput, {
                  "use-id-only": true,
                  "filter-fields": adsCabinetFilterFields.value,
                  "filter-values": [
                segment.platform_slug,
                ...adsCabinetFilterValues.value,
              ],
                  selectType: "ads_cabinet",
                  "is-disabled": segment.platform_slug == null,
                  "is-invalid": isInvalidForm.value && segment.ads_cabinet_id == null,
                  isSegmentSetted: false,
                  modelValue: segment.ads_cabinet_id,
                  "onUpdate:modelValue": ($event) => (segment.ads_cabinet_id = $event)
                }, null, 8, ["filter-fields", "filter-values", "is-disabled", "is-invalid", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ])
        ]),
        (_unref(authStore).getPayloadTenant() != _unref(rootGetters).inhouse_tenant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", {
                  class: _normalizeClass(["pointer", [segment.updatable_locked ? 'locked' : '']]),
                  for: "renewal"
                }, "Включить автопродление сегмента", 2),
                _withDirectives(_createElementVNode("span", _hoisted_41, null, 512), [
                  [_directive_tooltip, {
              value:
                'Если автопродление не выбрано, то через месяц обновление и использование сегмента в кабинете будет остановлено.',
              class: 'white-tooltip',
            }]
                ])
              ]),
              _createVNode(_unref(InputSwitch), {
                modelValue: segment.is_segment_auto_renewable,
                "onUpdate:modelValue": ($event: any) => ((segment.is_segment_auto_renewable) = $event),
                disabled: segment.updatable_locked,
                inputId: "renewal"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_42, [
          (campaign.value.campaign_segments.length > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "delete-button flex flex-center",
                onClick: ($event: any) => (deleteSegment(idx))
              }, _hoisted_45, 8, _hoisted_43))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "group-button flex flex-center",
            onClick: ($event: any) => (addSegment(idx))
          }, _hoisted_49, 8, _hoisted_46)
        ])
      ], 2))
    }), 128)),
    _createVNode(DuplicatedCampaignDialog, {
      id: duplicatedId.value,
      visible: confirmVisible.value.duplicate,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (confirmVisible.value.duplicate = false))
    }, null, 8, ["id", "visible"])
  ]))
}
}

})